module.exports = __webpack_public_path__ + "media/images/common/logo_site-eb9e59b3d88df269648eea844b88bbd3.png";